import React from 'react';

// Two response shapes are supported: page-based (totalPages/totalElements known
// up front) and slice-based (only hasNext/hasPrevious known, no total count).
const Pagination = ({page, totalPages, totalElements, hasNext, hasPrevious, onPageChange}) => {
  if (totalPages === undefined) {
    if (!hasNext && !hasPrevious) {
      return null;
    }

    return (
      <div className="pagination">
        <button
          type="button"
          className="btn-brand btn-brand-ghost"
          onClick={() => onPageChange(page - 1)}
          disabled={!hasPrevious}
        >
          Previous
        </button>
        <span className="pagination-status">Page {page + 1}</span>
        <button
          type="button"
          className="btn-brand btn-brand-ghost"
          onClick={() => onPageChange(page + 1)}
          disabled={!hasNext}
        >
          Next
        </button>
      </div>
    );
  }

  if (!totalPages || totalPages <= 1) {
    return null;
  }

  return (
    <div className="pagination">
      <button
        type="button"
        className="btn-brand btn-brand-ghost"
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 0}
      >
        Previous
      </button>
      <span className="pagination-status">
        Page {page + 1} of {totalPages} &middot; {totalElements} results
      </span>
      <button
        type="button"
        className="btn-brand btn-brand-ghost"
        onClick={() => onPageChange(page + 1)}
        disabled={page + 1 >= totalPages}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
